import { render, staticRenderFns } from "./InstructionalMatterView.vue?vue&type=template&id=8ffb657e&scoped=true"
import script from "./InstructionalMatterView.vue?vue&type=script&lang=js"
export * from "./InstructionalMatterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffb657e",
  null
  
)

export default component.exports